export default "__VITE_ASSET__CSYLBiIL__"